/**
 * A seated figure in meditation (head, arms to the knees, crossed legs), drawn on
 * lucide's 24px grid with its stroke conventions so it sits beside the other
 * nav icons. lucide-react (0.263) has no meditation glyph.
 */
import React from 'react';

const MeditationIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <circle cx="12" cy="5" r="2.2" />
    <path d="M4.5 15.5 8.3 10.6c.9-1.1 2.2-1.7 3.7-1.7s2.8.6 3.7 1.7l3.8 4.9" />
    <path d="M2 19.5c3-1.9 6.3-2.8 10-2.8s7 .9 10 2.8" />
  </svg>
);

export default MeditationIcon;
